import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=bd39acb2&scoped=true"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"
import style0 from "./UserCreate.vue?vue&type=style&index=0&id=bd39acb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd39acb2",
  null
  
)

export default component.exports